
<ng-container *ngIf="!tripStartOrEnd; else hasTrip">None</ng-container>
<ng-template #hasTrip>
    
    <p class="bold">Trip Type: <span>{{ formatStringForDisplay(tripStartOrEnd.definition) }}</span></p>
    <p class="bold">Inspection Types: <span>{{ tripInspectionTypes }}</span></p>
    <p class="bold">Inspection is expected within: <span>{{ tripStartOrEnd?.within }} minutes </span></p>
    <p class="bold">Frequency: <span>{{ formatStringForDisplay(tripStartOrEnd.frequency) }}</span>
    <p class="bold" *ngIf="zonesTripTypes.includes(tripStartOrEnd.definition)">Zones: <span>{{ tripZones }}</span></p>
    <p class="bold" *ngIf="tripStartOrEnd.timezone">Timezone: <span>{{ tripStartOrEnd.timezone | displayTimezone}}</span></p>

    
    <ng-container *ngIf="tripStartOrEnd?.workPeriods?.length">
        <p class="bold" *ngFor="let wp of tripStartOrEnd?.workPeriods">Check for an inspection every time on {{ translateIntsToDays(wp.days) }} between: <span>{{ rulesService.translateTimeToHumanReadable(wp.start)}} - {{ rulesService.translateTimeToHumanReadable(wp.end)}}.</span></p>
    </ng-container>
</ng-template>
